import { generatorSlideShow } from './custom-analytics-generator.js';

const GENERATOR_MAP = new Map([
  ['slideshow', generatorSlideShow]
]);

document.addEventListener('click', e => {
  const element = e.target.closest('[data-analytics-type]');

  if (!element) return;

  const type  = element.dataset.analyticsType;

  if (type) {
    const generator = GENERATOR_MAP.get(type);
    const details = generator ? generator(element, type) : {};
    gtag('event', 'custom_click', {
      'component_type' : type,
      ...details
    });
  }
});


